export const BUILD_TYPED = 'build';
export const JOB_TYPED = 'job';
export const SCENARIO_TYPED = 'scenario';
export const APP_TYPED = 'app';
export const NEEDS_INVESTIGATION = 'Needs Investigation';
export const UNDER_INVESTIGATION = 'Under Investigation';
export const TICKET_FILED = 'Ticket Filed';
export const NO_ACTION_REQUIRED = 'No Action Required';
export const UP_VOTE = 'UpVote';
export const DOWN_VOTE = 'DownVote';


export const getTypedIdName = (type) => {
  switch (type) {
    case SCENARIO_TYPED:
      return 'scenario_id';
    case BUILD_TYPED:
      return 'build_id';
    case JOB_TYPED:
      return 'job_id';
    case APP_TYPED:
      return 'app_id';
    default:
      return null;
  }
};

export const EXTRA_INFO_PROPS = {
  DISPATCHER_ID: 'dispatcher_id',
  DISPATCHER_TYPE: 'dispatcher_type'
};

export const ALL_ANNOTATIONS_STATUSES = {
  NEEDS_INVESTIGATION,
  UNDER_INVESTIGATION,
  TICKET_FILED,
  NO_ACTION_REQUIRED,
  UP_VOTE,
  DOWN_VOTE
};

export const ANNOTATION_STATUSES = [
  {
    title: ALL_ANNOTATIONS_STATUSES.NEEDS_INVESTIGATION,
    glyph: 'question-sign',
    quick: true
  },
  {
    title: ALL_ANNOTATIONS_STATUSES.UNDER_INVESTIGATION,
    glyph: 'eye-open',
    quick: true
  },
  {
    title: ALL_ANNOTATIONS_STATUSES.TICKET_FILED,
    glyph: 'remove',
    requiresTicket: true
  },
  {
    title: ALL_ANNOTATIONS_STATUSES.NO_ACTION_REQUIRED,
    glyph: 'minus',
    quick: true
  }
];

export const ANNOTATION_STATUSES_TITLES = [
  ANNOTATION_STATUSES[0].title,
  ANNOTATION_STATUSES[1].title,
  ANNOTATION_STATUSES[3].title,
];

export const getAnnotationGlyph = annotation => {
  if (!annotation) {
    return ANNOTATION_STATUSES[0].glyph;
  }

  if (!ANNOTATION_STATUSES.find(
    t => t.title.toLowerCase() === annotation.status.toLowerCase())) {
    // We don't know what icon to make this.
    return 'exclamation-sign';
  }

  return ANNOTATION_STATUSES.find(
    a => a.title.toLowerCase() === annotation.status.toLowerCase()).glyph;
};

export const getAnnotationGlyphFromList = (annotations, id) => {
  if (!annotations || !id || !annotations[id]) {
    return null;
  }

  return getAnnotationGlyph(annotations[id][0]);
};

export const getAnnotationStatusObject = annotation => {
  if (!annotation) {
    return ANNOTATION_STATUSES[0];
  }

  return ANNOTATION_STATUSES.find(
    a => a.title.toLowerCase() === annotation.status.toLowerCase());
};

export const getStatusRequiresTicket = status => ANNOTATION_STATUSES[status] &&
 ANNOTATION_STATUSES[status].requiresTicket;
export const getStatusTitle = status => ANNOTATION_STATUSES[status] &&
 ANNOTATION_STATUSES[status].title;
export const getStatusGlyph = status => ANNOTATION_STATUSES[status] &&
 ANNOTATION_STATUSES[status].glyph;
export const getStatusQuick = status => ANNOTATION_STATUSES[status] &&
 ANNOTATION_STATUSES[status].quick;

// deprecate this
export const getStatusTitles = () => {
  const list = [];
  for (let i = 0; i < ANNOTATION_STATUSES.length; i++) {
    list.push(ANNOTATION_STATUSES[i].title);
  }
  return list;
};

export const getScenarioStatusList = () => ANNOTATION_STATUSES.map((s) => {
  return { displayStatus: s.title };
});

export const getBuildFeedbackStatusList = () => [
  { displayStatus: ALL_ANNOTATIONS_STATUSES.UP_VOTE },
  { displayStatus: ALL_ANNOTATIONS_STATUSES.DOWN_VOTE }
];

export const createPayloadFromInfo = (info, dispatcherId, dispatcherType) => {
  let extraInfo = null;
  if (dispatcherId && dispatcherId !== 0 &&
    dispatcherType && dispatcherType !== '')
  {
    extraInfo =
    {
      [EXTRA_INFO_PROPS.DISPATCHER_TYPE]: dispatcherType,
      [EXTRA_INFO_PROPS.DISPATCHER_ID]: dispatcherId
    };
  }
  return {
    status: info.status,
    user: info.userName,
    ticket: info.ticket,
    comment: info.comment,
    'extra_info':extraInfo
  };
};

export const getUserAnnotation = (annotations) => {
  const resultResult = { id: 0, status: 'None' };
  if (!annotations)
  {
    return resultResult;
  }
  const username = localStorage.getItem('userName') || '';
  const annotation = annotations.filter(a => a.user === username);
  return annotation.length !== 0 ? annotation[0] : resultResult;
};


// WEBPACK FOOTER //
// src/helpers/annotation.js